module.exports = __webpack_public_path__ + "static/img/relief05.4e4d9b3.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/relief05.bmp
// module id = 7w3w
// module chunks = 2